import { Box, Typography } from "@mui/material";
import { MoviesSlider } from "./categoryList";
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import styled from "styled-components";
import { useCallback, useRef } from "react";
import { BackBarButtonMini } from "../common/backBarButton";
import { getArtistImageURL } from "../../utils/api.utils";
import smoothScroll from "../../utils/animateScroll";
import { useInputMode } from "../../utils/hooks/useInputMode";

const ContentWrapper = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 2rem 4rem;
  padding-bottom: 0;
`;

const ScrollingRows = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: 100vh;
  width: 100%;
`;

const ArtistContent = ({ data }) => {
  const { ref, focusKey } = useFocusable();
  const { artist, movies } = data;
  const { isMouseFocus } = useInputMode();

  const onRowFocus = useCallback(
    (props) => {
      if (isMouseFocus) return;
      const { y, height } = props;

      const targetScroll = y > height - 200 ? y - 200 : 0;

      smoothScroll(ref, targetScroll, 500);
    },
    [ref, isMouseFocus]
  );

  return (
    <ContentWrapper>
      <FocusContext.Provider value={focusKey}>
        <ScrollingRows ref={ref}>
          <div>
            <div className="mb-5">
              <BackBarButtonMini />
              <div className="flex items-end mt-5">
                <img
                  className="border-2 border-zinc-800 rounded-full"
                  src={getArtistImageURL(artist?.image)}
                  width={196}
                  height={196}
                  alt={artist?.farsiName || artist?.englishName}
                  style={{ objectFit: 'cover' }}
                />
                <div className="mb-5">
                  <Typography
                    variant="h5"
                    fontWeight={700}
                    mb={1}
                    mr={3}
                    color={"white"}
                    fontFamily={"AnjomanMax"}
                  >
                    {artist?.farsiName}
                  </Typography>
                  <Typography
                    variant="h5"
                    fontWeight={500}
                    mb={2}
                    mr={3}
                    color={"white"}
                    fontFamily={"AnjomanMax"}
                  >
                    {artist?.englishName}
                  </Typography>
                  <Typography
                    fontSize={18}
                    mb={0}
                    mr={3}
                    color={"white"}
                    fontFamily={"AnjomanMax"}
                  >
                    {artist?.description}
                  </Typography>
                </div>
              </div>
            </div>
            {movies?.length > 0 ? (
              <MoviesSlider
                rowTitle={""}
                movies={movies}
                onFocus={onRowFocus}
              />
            ) : (
              <div className="bg-[#212121] p-5 rounded-xl text-lg">
                <Typography color={"white"} fontFamily={"AnjomanMaxFN-Regular"}>
                  {" "}
                  محتوایی یافت نشد
                </Typography>
              </div>
            )}
          </div>
        </ScrollingRows>
      </FocusContext.Provider>
    </ContentWrapper>
  );
};

export default ArtistContent;
